"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultAnonUserPermissions = createDefaultAnonUserPermissions;
exports.createNoAccess = createNoAccess;
exports.createAnonUserPermissions = createAnonUserPermissions;
exports.createUserPermissionsForUser = createUserPermissionsForUser;
exports.canUserAccessDocument = canUserAccessDocument;
exports.userPermissionsToPermissionsMap = userPermissionsToPermissionsMap;
exports.userCanView = userCanView;
exports.userCanComment = userCanComment;
exports.userCanEdit = userCanEdit;
const constants_1 = require("@buildwithflux/constants");
const lodash_1 = require("lodash");
const accessList_1 = require("./accessList");
const documentPermissions_1 = require("./documentPermissions");
const permissionType_1 = require("./permissionType");
function createDefaultAnonUserPermissions() {
    return createAnonUserPermissions(permissionType_1.PermissionType.none);
}
/**
 * Create user permissions for a user that grant no access
 */
function createNoAccess(userUid) {
    return createUserPermissionsForUser(userUid, permissionType_1.PermissionType.none);
}
/**
 * Create user permissions for the anonymous user with a given level of access.
 */
function createAnonUserPermissions(permission) {
    return create(permission, true);
}
/**
 * Create user permissions for a specific user with a specific level of access.
 */
function createUserPermissionsForUser(userUid, permission) {
    return create(permission, false, userUid);
}
/**
 * Fundamental user permission creation function.  Creates permissions data for a specific user (inclusive of the anonymous user).
 */
function create(permission, setPermissionForAnyone, userUid) {
    if (!setPermissionForAnyone && !userUid) {
        const errorMessage = "Missing user UID while granting permission to a specific user.";
        throw new Error(errorMessage);
    }
    return {
        user_uid: setPermissionForAnyone ? constants_1.ANON_ROLE_UID : userUid,
        permission_type: permission,
        created_at: new Date().getTime(),
        updated_at: new Date().getTime(),
    };
}
/**
 * Checks whether a given user uid has permission to view a given document.
 */
function canUserAccessDocument(userUid, organizationMemberships, documentData) {
    const userAccessListIdentifiers = (0, accessList_1.generateUserAccessListForQuery)(userUid, organizationMemberships);
    return (0, lodash_1.intersection)(documentData.user_access_list || [], userAccessListIdentifiers).length > 0;
}
/**
 * Generate a user permissions map from a list of user permissions.
 */
function userPermissionsToPermissionsMap(roles) {
    return Object.fromEntries(roles.map((role) => [role.user_uid, role]));
}
/**
 * Check to see if a given user has at least view permissions on a document.
 */
function userCanView(userUidToCheck, documentOwnerUid, roles, documentOrganizationOwnerUid, documentOrganizationMemberPermissionType, documentEnterpriseOwnerUid, documentEnterpriseMemberPermissionType, organizationMemberships) {
    return ((0, documentPermissions_1.userPermissionType)(userUidToCheck, documentOwnerUid, roles, documentOrganizationOwnerUid, documentOrganizationMemberPermissionType, documentEnterpriseOwnerUid, documentEnterpriseMemberPermissionType, organizationMemberships, true) !== permissionType_1.PermissionType.none);
}
function userCanComment(userUidToCheck, documentOwnerUid, roles, documentOrganizationOwnerUid, documentOrganizationMemberPermissionType, documentEnterpriseOwnerUid, documentEnterpriseMemberPermissionType, organizationMemberships) {
    const effectivePermission = (0, documentPermissions_1.userPermissionType)(userUidToCheck, documentOwnerUid, roles, documentOrganizationOwnerUid, documentOrganizationMemberPermissionType, documentEnterpriseOwnerUid, documentEnterpriseMemberPermissionType, organizationMemberships, true);
    return effectivePermission === permissionType_1.PermissionType.edit || effectivePermission === permissionType_1.PermissionType.comment;
}
function userCanEdit(userUidToCheck, documentOwnerUid, roles, documentOrganizationOwnerUid, documentOrganizationMemberPermissionType, documentEnterpriseOwnerUid, documentEnterpriseMemberPermissionType, organizationMemberships, hasEditPrivateProjectEntitlement) {
    return ((0, documentPermissions_1.userPermissionType)(userUidToCheck, documentOwnerUid, roles, documentOrganizationOwnerUid, documentOrganizationMemberPermissionType, documentEnterpriseOwnerUid, documentEnterpriseMemberPermissionType, organizationMemberships, hasEditPrivateProjectEntitlement) === permissionType_1.PermissionType.edit);
}
//# sourceMappingURL=functions.js.map